import { sagaListSuccess } from "../actions/ActionTypes";
const initialState = { branches: [], countries: [] };

export default function memberLookups(state = initialState, action = {}) {
  switch (action.type) {
    case sagaListSuccess("MEMBER_LOOKUPS"):
      return { ...state, ...action.data.data };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/lookups.js